// Pipeline étapes du module Suivi commercial

export const COMMERCIAL_STAGES = [
  { id: "interesse", label: "Prospect intéressé", short: "Intéressé", color: "bg-brand-moss/10 text-brand-moss border-brand-moss/25" },
  { id: "rdv_programme", label: "Rendez-vous programmé", short: "RDV programmé", color: "bg-[#FAF8F1] text-[#6B5B33] border-[#E9E2CF]" },
  { id: "rdv_confirme", label: "Rendez-vous confirmé", short: "RDV confirmé", color: "bg-[#F5F2E6] text-[#6B5B33] border-[#E9E2CF]" },
  { id: "rdv_realise", label: "Rendez-vous réalisé", short: "RDV réalisé", color: "bg-brand-moss/15 text-brand-moss border-brand-moss/30" },
  { id: "proposition_a_preparer", label: "Proposition à préparer", short: "À préparer", color: "bg-brand-paper text-brand-ink border-brand-line" },
  { id: "proposition_envoyee", label: "Proposition envoyée", short: "Envoyée", color: "bg-brand-mossSoft text-brand-moss border-brand-moss/20" },
  { id: "negociation", label: "Négociation", short: "Négo", color: "bg-[#F1EEE4] text-[#5F5236] border-[#E0D9C4]" },
  { id: "signe", label: "Contrat signé", short: "Signé", color: "bg-brand-moss text-white border-brand-moss" },
  { id: "perdu", label: "Contrat perdu", short: "Perdu", color: "bg-[#F8F3F0] text-[#7A4B3A] border-[#E9DED8]" },
  { id: "abandonne", label: "Opportunité abandonnée", short: "Abandonné", color: "bg-brand-paper text-brand-subtle border-brand-line" },
];

export const STAGE_BY_ID = Object.fromEntries(COMMERCIAL_STAGES.map((s) => [s.id, s]));

export const APPOINTMENT_STATUSES = [
  { id: "programme", label: "Programmé", color: "bg-brand-paper text-brand-ink border-brand-line" },
  { id: "confirme", label: "Confirmé", color: "bg-brand-moss/10 text-brand-moss border-brand-moss/25" },
  { id: "realise", label: "Réalisé", color: "bg-brand-moss text-white border-brand-moss" },
  { id: "absent", label: "Absent", color: "bg-[#F8F3F0] text-[#7A4B3A] border-[#E9DED8]" },
  { id: "annule", label: "Annulé", color: "bg-[#F8F3F0] text-[#7A4B3A] border-[#E9DED8]" },
  { id: "reporte", label: "Reporté", color: "bg-[#FAF8F1] text-[#6B5B33] border-[#E9E2CF]" },
];

export const COMMISSION_STATUSES = {
  a_valider: { label: "À valider", color: "bg-[#FAF8F1] text-[#6B5B33] border-[#E9E2CF]" },
  validee: { label: "Validée", color: "bg-brand-moss/10 text-brand-moss border-brand-moss/25" },
  payee: { label: "Payée", color: "bg-brand-moss text-white border-brand-moss" },
};

export const stageById = (id) => STAGE_BY_ID[id] || COMMERCIAL_STAGES[0];
